import ecommerce from "../src/images/ecommerce.png";
import poke from "../src/images/poke.png";
import pelis from "../src/images/pelis.png"
import calculator from "../src/images/calculator.png";
import darkLight from "../src/images/darkLight.png";
import searchMovie from "../src/images/searchMovie.png";
import aves from "../src/images/aves.png";
import banner from "../src/images/banner.jpeg";
import automation from "../src/images/automation.jpeg";
import selenium from "../src/images/selenium.png";
import tetris from "../src/images/tetris.png";
import ecommerceWeb from "../src/images/ecommerceWeb.jpeg";

const mockData=[
    {
        title:"Ecommerce",
        image:ecommerceWeb,
        link:"https://github.com/DiegoYanezGonzalez/WebReactJs",
        description:"Web Site Ecommerce firt with ReactJs, HTML, CSS"
        
    },
    {
        title:"Tetris",
        image:tetris,
        link:"https://github.com/DiegoYanezGonzalez/JavaScriptTetrisHTML5",
        description:"Tetris game programming with JS and HTML5"
        
    },
    {
        title:"Selenium Project Platzi",
        image:selenium,
        link:"https://github.com/DiegoYanezGonzalez/seleniumPythonCoursePlatzi",
        description:"Course of Platzi Selenium with Python Automation web"
        
    },
    {
        title:"Barber Web Page",
        image:banner,
        link:"https://diebarber.netlify.app/",
        description:"Web page of a Barber Shop using JS, HTML, CSS"
        
    },
    {
        title:"Automation",
        image:automation,
        link:"https://github.com/DiegoYanezGonzalez/cypress",
        description:"Project testing automation to page Ecommerce practice automation with Cypress JS"
        
    },
    {
        title:"E-commerce",
        image:ecommerce,
        link:"https://github.com/DiegoYanezGonzalez/StoreReactNative",
        description:"Ecommerce iOS / Android Mobile App Using React Native"
        
    },
    {
        title:"PokeApp",
        image:poke,
        link:"https://github.com/DiegoYanezGonzalez/PokedexReactNative",
        description:"Aplication iOS / Android Mobile App Using React Native"
    },
    {
        title:"MoviesApp",
        image:pelis,
        link:"https://github.com/DiegoYanezGonzalez/ReactNativeMoviesApp",
        description:"Aplication iOS / Android Mobile App Using React Native"
    },
    {
        title:"Calculadora iOS",
        image:calculator,
        link:"https://github.com/DiegoYanezGonzalez/CalculadoraiOS",
        description:"Aplication IOS / Android Clone Mobile App of iOS Calculator, Built Using React Native"
    },
    {
        title:"Aves Chilenas",
        image:aves,
        link:"https://github.com/DiegoYanezGonzalez/ChileanBirds",
        description:"Android mobile application of Chilean Birds using Kotlin in Android Studio"
    },
];

export default mockData;